// extracted by mini-css-extract-plugin
export var searchHeader = "_2a-0";
export var searchHeaderDark = "_2a-1";